import React from "react";
import DateDropdown from "../../../components/reusable-ui/date-picker-dropdown";
import CustomTextField from "../../../components/reusable-ui/textfield-box";
import { allowEverything } from "../../../utils";
import CustomDropdown from "../../../components/reusable-ui/custom-dropdown";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import DeleteIcon from "@mui/icons-material/Delete";
import VerticalAlignBottomIcon from "@mui/icons-material/VerticalAlignBottom";

interface Props {
  handleDateSelection: any;
  isEditMode: boolean;
  currentTransactionDetails: any;
  transactionDate: any;
  text_Config: any;
  handleInputChange: any;
  errorMsgMap: any;
  dropdown_Config: any;
  transactionConfig: any;
  downloadAttachment: any;
  deleteAttachment: any;
  handleFileChange: any;
  isCashier?: boolean
}
function AddEditForm({
  handleDateSelection,
  isEditMode,
  currentTransactionDetails,
  transactionDate,
  text_Config,
  handleInputChange,
  errorMsgMap,
  dropdown_Config,
  transactionConfig,
  downloadAttachment,
  deleteAttachment,
  handleFileChange,
  isCashier = false
}: Props) {
  function renderTextField(textConfig: {
    label?: string;
    placeholder?: string;
    regexCheck?: any;
    onChange?: any;
    customClass?: string;
    parentClass?: string;
    value: string;
    key: string;
    maxLength?: number;
    iconClass?: string;
    rows?: number;
    isDisabled?: boolean;
    isMandatory: boolean;
  }) {
    return (
      <CustomTextField
        textBoxLabel={textConfig?.label || ""}
        placeholder={textConfig?.placeholder || ""}
        regexCheck={textConfig?.regexCheck || allowEverything}
        handleChange={(val: string) => handleInputChange(val, textConfig?.key)}
        customClass={`min-h-[44px] flex items-center px-16 text-16 font-normal ${
          textConfig?.customClass || ""
        }`}
        parentClass={textConfig?.parentClass || ""}
        value={textConfig?.value || ""}
        rows={textConfig?.rows || 1}
        isMandatory={textConfig.isMandatory}
        maxLength={textConfig?.maxLength || 10}
        errorMessage={errorMsgMap[textConfig?.key] || ""}
        iconClass={textConfig?.iconClass}
        isDisabled={textConfig?.isDisabled || false}
      ></CustomTextField>
    );
  }
  function renderCustomDropDown(dropdownConfig: {
    label?: string;
    optionsMap: any;
    isMultiSelect?: boolean;
    placeholder?: string;
    getListItemText?: any;
    parentClass?: string;
    dropdownHeading?: string;
    searchPlaceholder?: string;
    onSubmit: any;
    preSelectedValues: any;
    uniqueKey?: any;
    key: string;
    isDisabled?: boolean;
    isMandatory: boolean;
  }): any {
    return (
      <CustomDropdown
        textBoxLabel={dropdownConfig.label}
        optionsMap={dropdownConfig.optionsMap}
        isMultiSelect={dropdownConfig.isMultiSelect || false}
        placeholder={dropdownConfig.placeholder}
        getListItemText={(data: any) =>
          dropdownConfig.getListItemText
            ? dropdownConfig.getListItemText(data)
            : data?.name || ""
        }
        parentClass={`mb-[6px] ${
          dropdownConfig?.isDisabled ? "opacity-[0.5]" : ""
        } ${dropdownConfig.parentClass}`}
        dropdownHeading={dropdownConfig.dropdownHeading}
        searchPlaceholder={dropdownConfig.searchPlaceholder}
        onSubmit={dropdownConfig.onSubmit}
        preSelectedValues={dropdownConfig.preSelectedValues || ""}
        uniqueKey={dropdownConfig.uniqueKey || "mid"}
        errorMessage={errorMsgMap[dropdownConfig.key] || ""}
        isMandatory={dropdownConfig.isMandatory}
        isDisabled={dropdownConfig?.isDisabled || false}
      ></CustomDropdown>
    );
  }

  function renderFileChooser(): React.JSX.Element {
    return (
      <>
        <label className="attachment-cnt border border-[#CFD3D8] rounded-[8px] p-12 w-full custom-file-upload flex items-center cursor-pointer">
          <div className="flex items-center gap-10 cursor-pointer">
            <AttachFileIcon
              sx={{ color: "#0074FB", transform: "rotate(45deg)" }}
            />
            {transactionConfig?.file?.name ? (
              <span className="text-14 text-[#0074FB] font-inter font-semibold">
                {transactionConfig?.file?.name}
              </span>
            ) : (
              <span className="text-14 text-[#0074FB] font-inter font-semibold">
                Add Attachment
              </span>
            )}
          </div>
          <input
            style={{ display: "none" }}
            type="file"
            id={"uploadImage"}
            multiple={false}
            className="upload-file-input"
            accept="application/pdf, image/jpeg, image/png"
            onChange={(e: any) => handleFileChange(e, "file")}
          />
        </label>
        {errorMsgMap.file && (
          <p className="text-14 font-medium text-[#9A3131] pt-5">
            {errorMsgMap.file}
          </p>
        )}
      </>
    );
  }

  function renderAttachmentView(): React.JSX.Element {
    return (
      <div className="attachment-cnt">
        <div className="attachment-info-section flex justify-between items-center border border-[#CFD3D8] rounded-[8px] p-12">
          <div className="flex items-center gap-10">
            <AttachFileIcon
              sx={{ color: "#6C6C6C", transform: "rotate(45deg)" }}
            />
            <span className="text-15 text-[#020202]">
              {currentTransactionDetails.attachments[0].fileName}
            </span>
          </div>
          <div className="flex items-center gap-10">
            <VerticalAlignBottomIcon
              sx={{ color: "#0074FB", cursor: "pointer" }}
              onClick={downloadAttachment}
            />
            <DeleteIcon
              sx={{ color: "#F56969", cursor: "pointer" }}
              onClick={deleteAttachment}
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="transaction-form-cnt py-25 px-40 sm:px-15">
      <div className="grid grid-cols-2 gap-50 sm:block">
        {renderCustomDropDown(dropdown_Config.trxType)}
        {renderCustomDropDown(dropdown_Config.mode)}
      </div>
      <div className="grid grid-cols-2 gap-50 sm:block">
        {renderTextField(text_Config.amountId)}
        {renderCustomDropDown(dropdown_Config.branch)}
      </div>
      {transactionConfig.typeId === "1" && (
        <>{renderTextField(text_Config.receivedFrom)}</>
      )}
      {transactionConfig.typeId === "2" && (
        <>{renderTextField(text_Config.receivedTo)}</>
      )}
      {renderCustomDropDown(dropdown_Config.reason)}
      <DateDropdown
        startYear={2000}
        placeholder={"Transaction date"}
        parentClass={"mb-24"}
        customClass={"h-full rounded-[8px]"}
        onDateSelection={handleDateSelection}
        isMandatory={true}
        preSelectedDate={
          isEditMode
            ? currentTransactionDetails.transactionDate
            : transactionDate
        }
        isCashier = {isCashier}
      />
      {renderTextField(text_Config.remark)}
      {currentTransactionDetails.attachments?.length > 0 ? (
        <>{renderAttachmentView()}</>
      ) : (
        <>{renderFileChooser()}</>
      )}
    </div>
  );
}

export default AddEditForm;
